// removed by extract-text-webpack-plugin
module.exports = {"buttonDiv":"_2i3-HIKUaTdx5h3yGIXrpL","footer":"_2T3ts38butXOBX_LBZA6aI","lightGray":"_2q7ymAxOiL2pdc-ShDwQUE","svg":"_3tL7Wtgmr_-InjhhL9Q2ST","title":"_1ogSugtmrxghDr8TFVlxeY","wrapper":"_3jlVBAkRBu93cNdYWy9yPY"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Footer/styles.scss
 ** module id = 483
 ** module chunks = 0
 **/